<template>
    <div class="agent-protocol">
        <span class="form-href-terms" @click.stop="gotoAgreement">《律临律师智能体入驻服务协议》</span>
        <img
            ref="tip"
            class="icon"
            src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/tip-icon-black-1.png"
            alt=""
        />
        <veui-popover target="tip" position="top-start">
            <div class="tip-first-line">
                律师智能体是您的在线AI分身，利用文心大模型能力和您个人专业知识内容，
                它能在您忙碌时即时回答用户常见问题，给出专业法律见解与建议，能够智能评估问题价值，并引导用户主动提供线索
            </div>
            <div class="tip-second-line">
                i. 开通后您可随时前往左侧菜单 「律师智能体-角色设置」来操作律师智能体的上线/下线
            </div>
        </veui-popover>
    </div>
</template>

<script>
import {Popover} from 'veui';

export default {
    name: 'AgentProtocol',

    components: {
        'veui-popover': Popover
    },

    methods: {
        /**
         * 打开智能体协议文件
         */
        gotoAgreement() {
            window.open('https://lvlin-fe-saas.cdn.bcebos.com/agent-rule.pdf');
        }
    }
};
</script>

<style lang="less" scoped>
.agent-protocol {
    display: flex;
    align-items: center;

    .form-href-terms {
        font-size: 14px;
        color: #0052cc;
        cursor: pointer;
    }

    .icon {
        width: 16px;
        height: 16px;
    }
}

.tip-first-line {
    margin-bottom: 20px;
}

.tip-second-line {
    color: #848b99;
}
</style>
